/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useEffect, useState } from "react";
import { consumirServicioEncirptacion } from "../../api";
import Breadcrumcomponent from "../../components/BreadCrumbMex/BreadCrumb";
import FormCambiarContrasenia from "../../components/FormCambiarContrasenia/FormCambiarContrasenia";
import Page from "../../components/Page";
import {
  ambienteAplicacion,
  empresa,
  urlCambiarContraseniaProceso,
  urlValidacionesCambioContrasenia,
} from "../../constants/urls";
import Loading from "../../wrappers/Loading";
import { encriptarContrasenia } from "../../utils/Encriptar";
import { validarContraseniaNueva } from "../../components/InputsMex/validaciones";

const requiredMsg = "Este campo es obligatorio";

const CambiarContraseniaLoginContainer = ({
  history,
  qParams,
  loading,
  setLoading,
  addToast,
  validarToken = true,
  redirect = "/",
  title = "Actualizar Contraseña",
  msgAlerta = "",
}) => {
  const [showError, setShowError] = useState(false);
  const [validaciones, setValidaciones] = useState(null);

  const { validado, id } = qParams;

  useEffect(() => {
    getData();
  }, []);

  if (validarToken) {
    if (!validado || validado === "0" || !id || id === "") {
      history.push("/token-invalido");
      return null;
    }
  }

  const getData = async () => {
    setLoading(true);
    const body = {
      ambiente: ambienteAplicacion,
      empresa: empresa,
      data: {},
    };
    const { transaccion, validaciones } = await consumirServicioEncirptacion(
      urlValidacionesCambioContrasenia,
      body
    );

    if (transaccion) {
      setValidaciones(validaciones);
    }

    setLoading(false);
  };

  const onSubmit = async (data) => {
    const passUno = data.passUno;
    const passDos = data.passDos;

    if (passUno !== passDos) {
      addToast("AMBAS CONTRASEñAS DEBEN COINCIDIR!!".toUpperCase(), {
        appearance: "warning",
      });

      return;
    }

    setLoading(true);
    const Data = {
      cliCodigoCore: id,
      cliPasswordNueva: encriptarContrasenia(data.passUno),
      cliPasswordNuevaSinEncriptar: data.passUno,
    };

    const result = await consumirServicioEncirptacion(urlCambiarContraseniaProceso, Data);

    if (result.transaccion === false) {
      result.mensajes.forEach((mensaje) => {
        addToast(mensaje.textTitulo, {
          appearance: "warning",
        });
      });
    } else {
      addToast(result.mensaje, {
        appearance: "success",
      });
      history.push(redirect);
    }

    setLoading(false);
  };

  return (
    <Loading loading={loading}>
      <Page>
        {validaciones !== null && (
          <React.Fragment>
            <Breadcrumcomponent title={title} subtitle={title} noRedireccionar={false} />

            <div className='row mb-5'>
              <div className='col-12'>
                <div className='card border rounded-top'>
                  <div className='card-header my-3'>
                    <h3 className='font-mex'>{title}</h3>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-6 order-1 order-md-0 align-self-center'>
                        <FormCambiarContrasenia
                          showError={showError}
                          errorMsg={validaciones.msgInvalidContrasenia}
                          onSubmit={onSubmit}
                          names={{
                            uno: {
                              name: "passUno",
                              rules: {
                                requried: requiredMsg,
                                validate: validarContraseniaNueva(
                                  validaciones,
                                  setShowError
                                ),
                              },
                            },
                            dos: {
                              name: "passDos",
                              rules: {
                                requried: requiredMsg,
                                validate: validarContraseniaNueva(
                                  validaciones,
                                  setShowError
                                ),
                              },
                            },
                          }}
                        />
                      </div>
                      {validaciones.msgInformacion && (
                        <div className='col-md-6 order-0 order-md-1  align-self-center'>
                          <div
                            className='alert alert-success mt-4 font-mex'
                            dangerouslySetInnerHTML={{
                              __html: validaciones.msgInformacion,
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </Page>
    </Loading>
  );
};

export default CambiarContraseniaLoginContainer;
